import { addEmployee } from '@/api/employee';
import { useState } from 'react';
import { useForm } from 'react-hook-form';

const useAddEmployee = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const addEmployeeForm = useForm({
    defaultValues: {
      fullname: '',
      phone: '',
      password: '',
      email: '',
      role: '',
    },
  });

  const onSubmit = async (
    employee: EmployeeToAdd,
    onSuccess: (message: string) => void,
    onError: (message: string) => void
  ) => {
    setIsSubmitting(true);

    // format phone, if it starts with zero remove it else keep evertything as it is
    if (employee.phone.startsWith('0')) {
      employee.phone = '+213' + employee.phone.slice(1);
    }

    console.log(employee);

    try {
      const response = await addEmployee({ status: 'Active', ...employee });
      console.log('response ', response);
      if (
        response.data.code === 'P2002' &&
        response.data.meta &&
        response.data.meta.target
      ) {
        // Extract the duplicated field from the meta data.
        const duplicatedField = response.data.meta.target.join(', ');
        // Log the error details for debugging purposes.

        // Return an error message in French indicating the duplicated field.
        setIsSubmitting(false);
        return onError(
          `Erreur : Le champ ${duplicatedField} est déjà utilisé. Veuillez en choisir un autre.`
        );
      } else if (response.status === 201) {
        // If no error, call the success handler.
        setIsSubmitting(false);
        onSuccess('employee ajouté avec succès');
      }
    } catch (error) {
      setIsSubmitting(false);
      onError("Erreur lors de l'ajout de l'employee");
    }
  };

  return { isSubmitting, addEmployeeForm, onSubmit };
};

export default useAddEmployee;
